import { render, staticRenderFns } from "./DoctorAgreement.vue?vue&type=template&id=eaf8dc16&"
import script from "./DoctorAgreement.vue?vue&type=script&lang=js&"
export * from "./DoctorAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports